import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import useMessages from '../../../hooks/chat/useMessages';
import { useChat } from '../../../context/provider/ChatProvider';

const ConversationContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1vh;
    flex: 1;
    padding: 20px 0;
    overflow: auto;
    max-height:300px;
`;

const MessageContent = styled.div`

    display: flex;
    font-size: 0.8em;
    font-weight: 300;
    padding: 0.8em 1em;
    width: fit-content;
    height: fit-content;

`;

const MessageContainer = styled.div`

    display: flex;
    gap: 20px;
    color: #000000;
    font-size: 1rem;
    flex-direction: ${ props => props.incomingMessage ? 'row' : 'row-reverse' };

    ${ MessageContent } {
        background: ${ props => props.incomingMessage ? '#004F7C' : '#ffffff' };
        border: ${ props => props.incomingMessage ? 'none' : '1px solid rgba(0, 0, 0, 0.1)' };
        color: ${ props => props.incomingMessage ? '#fff' : '#000' };
        box-shadow:  ${ props => props.incomingMessage ? 'rgba(32, 112, 198, 0.4)' : 'rgba(0, 0, 0, 0.15)'} 2px 3px 15px;
        border-radius: ${ props => props.incomingMessage ? '0 8px 8px 8px' : '8px 0 8px 8px' };
    }
`;

const UserProfile = styled.div`
    display: flex;
    position: relative;
    height: 100%;

    &::before {
        content: '${props => props.content.split("@")[0]}';
        display: grid;
        place-content: center;
        padding: 1em;
        width: 5.3em;
        height: 1.3em;
        border-radius: 10%;
        background: #004268;
        color:#fff;
    }
`
const BotMessage = styled.div`
    width: fit-content;
    margin: 0 auto;
    padding: 0.85em 1.7em;
    font-size: 0.7em;
    text-align: center;
    border-radius: 2em;
    background: rgba(0,0,0,0.05);
`;

const Conversation = () => {
    const { socket } = useChat();
    const messages = useMessages();
    const chatConversation = useRef(null);
    
    // auto scroll to bottom on new message recieve / sent
    useEffect(() => {
        chatConversation.current.scrollTo(0, chatConversation.current.scrollHeight);    
    }, [messages]);

    return (
        <ConversationContainer className="containerScroll" ref={ chatConversation }>
            {
                messages.map((m) => {
                    const { text, author, socket_id, id } = m;

                    const isBot = (author === 'BOT' && ! socket_id);
                    
                    return isBot ?
                        <BotMessage> { text } </BotMessage>
                    :
                    (
                        <MessageContainer key={ id } incomingMessage={ socket_id !== socket.id }>
                            <UserProfile content={ author } />
                            <MessageContent>{ text }</MessageContent>
                        </MessageContainer>
                    );
                })
            }
        </ConversationContainer>
    );
};

export default Conversation;